module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goVideoCategories()
      }
    }
  }, [_vm._v("戻る")])])]), _c('section', {
    staticClass: "content"
  }, [_c('dl', {
    staticClass: "container"
  }, [_c('dt', [_vm._v("ハウスルール　注意すべき行動・報告")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M16.mp4",
      "poster": _vm.poster('M16'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("店内設備（一例）")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M17.mp4",
      "poster": _vm.poster('M17'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("台鍵の取り扱い")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M18.mp4",
      "poster": _vm.poster('M18'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("遊技台ガラスの開け閉め・台の開け閉め")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M19.mp4",
      "poster": _vm.poster('M19'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65177b8d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/video-raw-facility.pug
// module id = 1408
// module chunks = 1